define( [
	"./arr"
], function( arr ) {
	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 275
// module chunks = 0